import { render, staticRenderFns } from "./goByStudentId.vue?vue&type=template&id=b065c1d6&scoped=true"
import script from "./goByStudentId.vue?vue&type=script&lang=js"
export * from "./goByStudentId.vue?vue&type=script&lang=js"
import style0 from "./goByStudentId.vue?vue&type=style&index=0&id=b065c1d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b065c1d6",
  null
  
)

export default component.exports